<template>
  <div>
    <div v-responsive.lg.xl class="country-code-select" ref="selectContainerDesktop">
      <div class="selected-country" @click="toggleDropdown" :class="{ open: isOpen }">
        <span class="flag">{{ selectedCountry.flag }}</span>
        <span class="code">{{ selectedCountry.code }}</span>
        <span class="arrow">&#9660;</span>
      </div>

      <!-- Regrouper tous les éléments dropdown dans un seul conteneur -->
      <div v-if="isOpen" class="dropdown-container" ref="dropdownContainer">
        <div class="dropdown">
          <div class="search-container">
            <input
              type="text"
              v-model="searchQuery"
              :placeholder="searchPlaceholder"
              :style="{ '::placeholder': { color: 'black' } }"
              class="search-input"
              ref="searchInput"
            />
          </div>
        </div>

        <div class="dropdown-liste">
          <div class="options-container">
            <div
              v-for="country in filteredCountries"
              :key="country.iso2"
              class="option"
              @click="selectCountry(country)"
              :class="{ selected: country.code === selectedCountry.code }"
            >
              <span class="flag">{{ country.flag }}</span>
              <span class="code">{{ country.code }}</span>
              <span class="country-name">{{ country.country }}</span>
              <span v-if="country.code === selectedCountry.code" class="checkmark">✓</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-responsive.sm.xs class="country-code-select" ref="selectContainerMobile">
      <div class="selected-country-mobile" @click="toggleDropdown" :class="{ open: isOpen }">
        <span class="flag">{{ selectedCountry.flag }}</span>
        <span class="code">{{ selectedCountry.code }}</span>
        <span class="arrow">&#9660;</span>
      </div>

      <!-- Regrouper tous les éléments dropdown dans un seul conteneur -->
      <div v-if="isOpen" class="dropdown-container" ref="dropdownContainer">
        <div class="dropdown">
          <div class="search-container">
            <input
              type="text"
              v-model="searchQuery"
              :placeholder="searchPlaceholder"
              class="search-input"
              ref="searchInput"
            />
          </div>
        </div>

        <div class="dropdown-liste">
          <div class="options-container">
            <div
              v-for="country in filteredCountries"
              :key="country.iso2"
              class="option"
              @click="selectCountry(country)"
              :class="{ selected: country.code === selectedCountry.code }"
            >
              <span class="flag">{{ country.flag }}</span>
              <span class="code">{{ country.code }}</span>
              <span class="country-name">{{ country.country }}</span>
              <span v-if="country.code === selectedCountry.code" class="checkmark">✓</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IntlNumber from '../common/intlNumber.json';

export default {
  name: 'CountryCodeSelect',
  props: {
    value: {
      type: String,
      default: '+221'
    },
    searchPlaceholder: {
      type: String,
      default: 'Rechercher un pays...'
    }
  },
  data() {
    return {
      isOpen: false,
      searchQuery: '',
      countries: IntlNumber
    };
  },
  computed: {
    selectedCountry() {
      return (
        this.countries.find((country) => country.code === this.value) ||
        this.countries.find((country) => country.code === '+221')
      );
    },
    filteredCountries() {
      if (!this.searchQuery) {
        return this.countries;
      }
      const query = this.searchQuery.toLowerCase();
      return this.countries.filter(
        (country) => country.country.toLowerCase().includes(query) || country.code.includes(query)
      );
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.$nextTick(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus();
          }
        });
      } else {
        this.searchQuery = '';
      }
    },
    selectCountry(country) {
      this.$emit('input', country.code);
      this.isOpen = false;
      this.searchQuery = '';
    },
    handleClickOutside(event) {
      const desktopContainer = this.$refs.selectContainerDesktop;
      const mobileContainer = this.$refs.selectContainerMobile;

      const clickedInsideDesktop = desktopContainer && desktopContainer.contains(event.target);
      const clickedInsideMobile = mobileContainer && mobileContainer.contains(event.target);

      if (!clickedInsideDesktop && !clickedInsideMobile) {
        this.isOpen = false;
        this.searchQuery = '';
      }
    },

    toggleDropdown() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.$nextTick(() => {
          // Focus sur le bon input selon le device
          const searchInput = this.$refs.searchInput || this.$refs.searchInputMobile;
          if (searchInput) {
            searchInput.focus();
          }
        });
      } else {
        this.searchQuery = '';
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style scoped>
.country-code-select {
  position: relative;
  display: inline-block;
}

.selected-country {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid #ccc;
  border-right: none;
  border-radius: 10px 0 0 10px;
  cursor: pointer;
  height: 45px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
}

.selected-country-mobile {
  display: flex;
  align-items: center;
  padding: 9.5px 12px;
  background: #fff;
  border: 1px solid #ccc;
  border-right: none;
  border-radius: 10px 0 0 10px;
  cursor: pointer;
  //height: 36px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
}

.selected-country:focus-within,
.selected-country-mobile:focus-within {
  border-color: #ffa409;
  box-shadow: 0 0 0 3px rgba(255, 164, 9, 0.18);
}

.flag {
  margin-right: 8px;
  font-size: 16px;
}

.code {
  flex: 1;
  font-size: 14px;
  color: #0d4e78;
  font-weight: 500;
  margin-right: 10px;
}

.arrow {
  font-size: 10px;
  color: #0d4e78;
  transition: transform 0.3s ease;
}

.selected-country.open .arrow,
.selected-country-mobile.open .arrow {
  transform: rotate(180deg);
}

.dropdown-container {
  position: absolute;
  top: 110%;
  left: 0;
  z-index: 1000;
  width: 225px;
  background: #fff;
  border: 1px solid rgba(13, 78, 120, 0.22);
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.dropdown-liste {
  max-height: 150px;
  overflow: hidden;
}
.search-container {
  padding: 8px;
  border-bottom: 1px solid rgba(13, 78, 120, 0.22);
  background: #fff;
}

.search-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid rgba(13, 78, 120, 0.22);
  border-radius: 10px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
}

.search-input::placeholder {
  color: #999;
}

.search-input:focus {
  border-color: #ffa409;
  box-shadow: 0 0 0 3px rgba(255, 164, 9, 0.18);
}

.options-container {
  max-height: 200px;
  overflow-y: auto;
}

.option {
  display: flex;
  align-items: center;
  padding: 2px 10px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.option:hover {
  background-color: #fff3e0;
}

.option.selected {
  background-color: #fff3e0;
}

.option .flag {
  margin-right: 10px;
  font-size: 16px;
}

.option .code {
  min-width: 50px;
  font-weight: 400;
  color: #333;
  margin-right: 20px;
}

.option .country-name {
  flex: 1;
  font-size: 12px;
  color: #000;
}

.checkmark {
  color: #ffa409;
  font-weight: bold;
  margin-left: 8px;
}

.options-container::-webkit-scrollbar {
  width: 6px;
}

.options-container::-webkit-scrollbar-track {
  background: #f5f5f5;
}

.options-container::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}

.options-container::-webkit-scrollbar-thumb:hover {
  background: #999;
}
</style>
